/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const jiraVersionModelSchema = z.object({
  archived: z.boolean(),
  id: z.string(),
  name: z.string(),
  released: z.boolean(),
});
